import * as S from './styles'

interface GraphLegendsProps {
  data: { label: string; fill: string }[]
}

export const GraphLegends: React.FC<GraphLegendsProps> = ({ data }) => {
  return (
    <S.Wrapper>
      {data.map((item, index) => (
        <S.LabelRow key={index}>
          <S.CircleIcon fill={item.fill} />
          <S.LabelText>{item.label}</S.LabelText>
        </S.LabelRow>
      ))}
    </S.Wrapper>
  )
}
